// Mock data for Lilly Of The Valley Inn
// TODO: Replace with actual data from backend/database

export const hotelInfo = {
  name: "Lilly Of The Valley Inn",
  tagline: "Where Luxury Meets Nature",
  description: "Experience the perfect blend of modern luxury and traditional Sri Lankan hospitality in the heart of Kandy's breathtaking landscape. Our boutique hotel offers stunning mountain views, world-class amenities, and unforgettable experiences.",
  location: "Kandy, Sri Lanka",
  phone: "+94 70 774 6357", // TODO: Replace with actual phone number
  whatsapp: "+94707746357", // TODO: Replace with actual WhatsApp number (without +)
  email: "info@lillyofthevalleyinn.com",
  // TODO: Add actual social media links
  socialMedia: {
    facebook: "https://facebook.com/lillyofthevalleyinn",
    instagram: "https://instagram.com/lillyofthevalleyinn",
    twitter: "https://twitter.com/lillyvalleyinn"
  },
  // TODO: Add actual booking platform URLs
  bookingLinks: {
    agoda: "https://www.agoda.com/search",
    booking: "https://www.booking.com/search"
  }
};

export const stats = [
  { icon: "building", value: "24", label: "Premium Rooms" },
  { icon: "award", value: "15+", label: "Years Excellence" },
  { icon: "users", value: "5K+", label: "Happy Guests" },
  { icon: "star", value: "4.9", label: "Rating" }
];

// TODO: Replace with actual room data from database
export const rooms = [
  {
    id: 1,
    name: "Deluxe Garden View Suite",
    description: "Spacious suite with king-size bed, private balcony overlooking lush gardens, and modern amenities.",
    price: "$120",
    pricePerNight: 120,
    capacity: 2,
    size: "35 sqm",
    amenities: ["King Bed", "Garden View", "Private Balcony", "Free WiFi", "AC", "Mini Bar"],
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800"
  },
  {
    id: 2,
    name: "Mountain View Suite",
    description: "Luxurious room with panoramic mountain views, sitting area, and premium furnishings.",
    price: "$150",
    pricePerNight: 150,
    capacity: 2,
    size: "40 sqm",
    amenities: ["King Bed", "Mountain View", "Sitting Area", "Free WiFi", "AC", "Coffee Maker"],
    image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800"
  },
  {
    id: 3,
    name: "Family Suite",
    description: "Perfect for families with two bedrooms, living area, and connecting bathroom.",
    price: "$180",
    pricePerNight: 180,
    capacity: 4,
    size: "55 sqm",
    amenities: ["2 Bedrooms", "Living Area", "Garden View", "Free WiFi", "AC", "Mini Fridge"],
    image: "https://images.unsplash.com/photo-1566665797739-1674de7a421a?w=800"
  },
  {
    id: 4,
    name: "Premium Honeymoon Suite",
    description: "Romantic suite with four-poster bed, jacuzzi, and private terrace with sunset views.",
    price: "$220",
    pricePerNight: 220,
    capacity: 2,
    size: "50 sqm",
    amenities: ["Four-Poster Bed", "Jacuzzi", "Private Terrace", "Free WiFi", "AC", "Champagne"],
    image: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800"
  }
];

// TODO: Replace with actual reviews from Google, Agoda, and Booking.com APIs
export const reviews = {
  google: [
    {
      id: 1,
      author: "Sarah Johnson",
      rating: 5,
      date: "2 weeks ago",
      text: "Absolutely stunning property! The views are breathtaking and the staff went above and beyond to make our stay memorable. The breakfast was delicious with local and international options.",
      platform: "Google"
    },
    {
      id: 2,
      author: "Michael Chen",
      rating: 5,
      date: "1 month ago",
      text: "Perfect location to explore Kandy. The rooms are spacious and beautifully decorated. Highly recommend the mountain view suite!",
      platform: "Google"
    }
  ],
  agoda: [
    {
      id: 3,
      author: "Emma Williams",
      rating: 4.8,
      date: "3 weeks ago",
      text: "Wonderful boutique hotel with personalized service. The gardens are beautifully maintained and the pool area is very relaxing.",
      platform: "Agoda"
    },
    {
      id: 4,
      author: "David Kumar",
      rating: 5,
      date: "1 month ago",
      text: "Exceptional hospitality! The team arranged all our tours and the recommendations were spot on. Will definitely return!",
      platform: "Agoda"
    }
  ],
  booking: [
    {
      id: 5,
      author: "Lisa Anderson",
      rating: 4.9,
      date: "2 weeks ago",
      text: "Clean, comfortable, and beautifully designed rooms. The location is perfect for visiting the Temple of the Tooth. Great value for money!",
      platform: "Booking.com"
    },
    {
      id: 6,
      author: "James Taylor",
      rating: 5,
      date: "3 weeks ago",
      text: "One of the best hotels we've stayed at in Sri Lanka. The attention to detail is impressive and the breakfast spread is amazing!",
      platform: "Booking.com"
    }
  ]
};

export const services = [
  {
    id: 1,
    icon: "utensils",
    title: "Restaurant & Bar",
    description: "Savor authentic Sri Lankan cuisine and international dishes prepared by our expert chefs. Enjoy cocktails at our rooftop bar with panoramic views."
  },
  {
    id: 2,
    icon: "spa",
    title: "Spa & Wellness",
    description: "Rejuvenate with traditional Ayurvedic treatments and modern spa therapies. Our wellness center offers yoga sessions and meditation."
  },
  {
    id: 3,
    icon: "wifi",
    title: "Free High-Speed WiFi",
    description: "Stay connected with complimentary high-speed internet throughout the property, perfect for both leisure and business travelers."
  },
  {
    id: 4,
    icon: "car",
    title: "Airport Transfer",
    description: "Convenient pick-up and drop-off services to/from Bandaranaike International Airport. Pre-book for hassle-free travel."
  },
  {
    id: 5,
    icon: "map",
    title: "Tour Arrangements",
    description: "Explore Kandy and beyond with our curated tour packages. From cultural sites to nature trails, we arrange it all."
  },
  {
    id: 6,
    icon: "coffee",
    title: "24/7 Room Service",
    description: "Round-the-clock room service ensuring your comfort at any hour. Order from our extensive menu anytime."
  }
];

export const placesToVisit = [
  {
    id: 1,
    name: "Temple of the Sacred Tooth Relic",
    distance: "2.5 km",
    description: "A UNESCO World Heritage site and one of the most sacred Buddhist temples in the world, housing a tooth relic of Buddha.",
    image: "https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800",
    duration: "2-3 hours"
  },
  {
    id: 2,
    name: "Royal Botanical Gardens",
    distance: "6 km",
    description: "Sprawling 147-acre gardens featuring over 4,000 species of plants, including orchids, spices, and medicinal plants.",
    image: "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=800",
    duration: "2-4 hours"
  },
  {
    id: 3,
    name: "Kandy Lake",
    distance: "2 km",
    description: "A picturesque artificial lake in the heart of Kandy, perfect for evening strolls and enjoying the scenic beauty.",
    image: "https://images.unsplash.com/photo-1577717883824-50e1531c2c18?w=800",
    duration: "1-2 hours"
  },
  {
    id: 4,
    name: "Udawattakele Forest Reserve",
    distance: "3 km",
    description: "A historic forest reserve offering nature trails, bird watching, and serene meditation spots amidst lush greenery.",
    image: "https://images.unsplash.com/photo-1511497584788-876760111969?w=800",
    duration: "3-4 hours"
  },
  {
    id: 5,
    name: "Bahiravokanda Vihara Buddha Statue",
    distance: "4 km",
    description: "A giant Buddha statue overlooking Kandy city, offering panoramic views and a peaceful atmosphere.",
    image: "https://images.unsplash.com/photo-1604608672516-f1b9b1a79e6d?w=800",
    duration: "1-2 hours"
  },
  {
    id: 6,
    name: "Ceylon Tea Museum",
    distance: "8 km",
    description: "Learn about Sri Lanka's tea heritage and enjoy tea tasting sessions at this informative museum.",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800",
    duration: "1-2 hours"
  }
];

export const  heroGallery = [
  'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1600',
  'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600',
  'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=1600',
  'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1600'
];


// Mock availability data - TODO: Replace with actual booking system integration
export const generateMockAvailability = (checkIn, checkOut) => {
  // Simulate availability check
  return rooms.map(room => ({
    ...room,
    available: Math.random() > 0.3, // 70% chance of being available
    remainingRooms: Math.floor(Math.random() * 5) + 1
  }));
};
